import { parseSignInIdentifier } from '@chukua/common';

/** `start` and `code` sign in with a code; `password` may be followed by `twoFactor`. A code is never followed by anything. */
export type LoginStep = 'start' | 'code' | 'password' | 'twoFactor';

/** Without a channel to send a code by, the password is the only way in, so it stands in for the start step. */
export function shownLoginStep(step: LoginStep, isCodeOffered: boolean): LoginStep {
  return !isCodeOffered && step === 'start' ? 'password' : step;
}

/** An email typed on the start step carries over to the password form; a mobile doesn't, since the form asks for an email. */
export function carriedOverEmail(typed: string): string | undefined {
  const identifier = parseSignInIdentifier(typed);
  return identifier?.kind === 'email' ? identifier.value : undefined;
}

/** What follows a password; where no code can be sent, why the password is the only way in. */
export function passwordStepLead(isCodeOffered: boolean): string {
  return isCodeOffered
    ? 'With a password, your two-factor check follows if you have one on.'
    : 'Sign-in codes are not set up here, so sign in with your email and password.';
}
